import React from 'react';
import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';

import './Masonry.sass';

@withMediaQueries({1: '(max-width: 767px)', 2: '(min-width: 768px) and (max-width: 991px)', 3: '(min-width: 992px)'}, {3: true}, 'columns')
export default class Masonry extends React.PureComponent {
  render() {
    const {columns, children} = this.props;
    const columnCount = Number(Object.keys(columns).find(key => columns[key]));

    const childrenArray = React.Children.toArray(children);

    return (
      <div className="masonry">
        {(new Array(columnCount)).fill().map((_, columnIdx) => (
          <div
            key={columnIdx}
            className="masonry__column"
          >
            {childrenArray.filter((_, childIdx) => childIdx % columnCount === columnIdx)}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/masonry/Masonry.js